<template>
    <div class="page">
        <img class="bg-pic" src="@/assets/new/company.png" alt="" />
        <div class="content-center">
            <h3>集团旗下子公司</h3>
            <span class="line"></span>
            <ul>
                <li @click="$router.push('/yldDetail')">
                    <img src="../assets/Group 34085@2x.png" alt="">
                    <p>福建易联达商务服务有限公司</p>
                </li>
                <li class="xll" @click="$router.push('/xllDetail')">
                    <img src="../assets/图层 1 7@2x.png" alt="">
                    <p>福建乡里郎电子商务有限公司</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "Subsidiary",
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}
h3 {
    font-weight: normal;
}
.page {
  padding-top: 65px;
    .bg-pic {
        width: 100%;
        display: block;
    }
}

/* ========== PC 端（保持你原来的样式） ========== */
.content-center {
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 20px;
    h3 {
        font-size: 18px;
        color: #DE1F26;
    }
    .line {
        width: 100%;
        height: 1px;
        margin: 10px 0;
        display: inline-block;
        background: #D9D9D9;
    }
    ul {
        list-style: none;
        margin-top: 40px;
        display: flex;
        gap: 50px;
        justify-content: flex-start;
        li {
            cursor: pointer;
            width: 269px;
            height: 210px;
            border: 1px solid #DE1F26;
            position: relative;
            img {
                width: 220px;
                height: 24px;
                margin: 74px 0 0 24px;
                display: inline-block;
            }
            p {
                margin-top: 65px;
                width: 269px;
                height: 40px;
                line-height: 40px;
                background-color: #DE1F26;
                color: #fff;
                text-align: center;
                position: absolute;
                bottom: 0;
            }
        }
        .xll {
            img {
                width: 228px;
                height: 72px;
                margin: 44px 0 0 24px;
            }
            p {
                margin-top: 48px;
            }
        }
    }
}

/* ========== 移动端适配（自动生效） ========== */
@media screen and (max-width: 768px) {
    .content-center {
        padding: 20px 15px;
        height: auto;
    }
    ul {
        flex-direction: column !important;
        align-items: center !important;
        gap: 20px !important;
    }
    li {
        width: 100% !important;
        max-width: 280px;
    }
    p {
        width: 100% !important;
    }
}
</style>
